import { getBaseCiRequestUrl, getToken } from '@/utils/constants'
import { httpRequest } from '@/utils/HttpRequest'
import { IPage } from '@/types/AppTypes'
import {
    SettleConfigInsert, SettleConfigUpdate, SettleConfigDetail
} from "./SettleConfigTypes";

class SettleConfigService {
    async page(searchVo: any) {
        const apiUrl = '/yh-franchisee/settlementCycle/list';
        return await httpRequest.post<IPage<SettleConfigDetail>>(apiUrl, searchVo, { baseURL: getBaseCiRequestUrl(), token: getToken() });
    }
    async one(id: string) {
        const apiUrl = `/yh-franchisee/settlementCycle/one/${id}`;
        return await httpRequest.get<SettleConfigDetail>(apiUrl, { baseURL: getBaseCiRequestUrl(), token: getToken() });
    }
    async insert(insertVo: SettleConfigInsert) {
        const apiUrl = '/yh-franchisee/settlementCycle/insert';
        return await httpRequest.post<boolean>(apiUrl, insertVo, { baseURL: getBaseCiRequestUrl(), token: getToken() });
    }
    async update(updateVo: SettleConfigUpdate) {
        const apiUrl = '/yh-franchisee/settlementCycle/update';
        return await httpRequest.post<boolean>(apiUrl, updateVo, { baseURL: getBaseCiRequestUrl(), token: getToken() });
    }
}

export const settleConfigService = new SettleConfigService()
